import { Characteristic } from '../../types';

export const characteristicsTR: Characteristic[] = [
  // Varoluş kategorisi
  {
    id: 'ambition',
    name: 'Hırslılık',
    category: 'being',
    description: 'Hedef belirleme ve motivasyon seviyenizi yansıtır',
  },
  {
    id: 'boldness',
    name: 'Cesaret',
    category: 'being',
    description: 'Hesaplanmış risk alma konusundaki rahatlığınızı ölçer',
  },
  {
    id: 'integrity',
    name: 'Dürüstlük',
    category: 'being',
    description: 'Ahlaki ilkelere bağlılığınızı değerlendirir',
  },
  {
    id: 'positiveOutlook',
    name: 'Olumlu Bakış Açısı',
    category: 'being',
    description: 'Yaşama iyimser bakış açınızı değerlendirir',
  },
  // Yapma kategorisi
  {
    id: 'passion',
    name: 'Dinamik Enerji',
    category: 'doing',
    description: 'Duygusal motivasyonunuzu ve hevesinizi değerlendirir',
  },
  {
    id: 'sociability',
    name: 'Sosyallik',
    category: 'doing',
    description: 'Sosyal etkileşimlerdeki rahatlığınızı ölçer',
  },
  {
    id: 'communication',
    name: 'İletişim',
    category: 'doing',
    description: 'Fikirleri net bir şekilde aktarma yeteneğinizi değerlendirir',
  },
  {
    id: 'wisdom',
    name: 'Muhakeme',
    category: 'doing',
    description: 'Bilgiyi etkili bir şekilde uygulama yeteneğinizi ölçer',
  },
  // Sahip olma kategorisi
  {
    id: 'learning',
    name: 'Öğrenme',
    category: 'having',
    description: 'Sürekli büyümeye olan bağlılığınızı değerlendirir',
  },
  {
    id: 'creativity',
    name: 'Yaratıcılık',
    category: 'having',
    description: 'Yenilikçi düşünme becerilerinizi değerlendirir',
  },
  {
    id: 'flexibility',
    name: 'Uyum Yetenegi',
    category: 'having',
    description: 'Değişime uyum sağlamanızı ölçer',
  },
  {
    id: 'visionaryThinking',
    name: 'Vizyoner Düşünce',
    category: 'having',
    description: 'Gelecek olasılıklarını görme yeteneğinizi değerlendirir',
  },
];
